import { FC } from 'react';
import { Table as AntDTable, TableProps } from 'antd';
import styled from 'styled-components';
import { useThemeContext, themeConfig } from '@/shared/theme';

export const Table: FC<TableProps<any>> = (props) => {
  const { theme } = useThemeContext();

  return (
    <TableWrapper
      $headerBackgroundColor={themeConfig[theme].colors.contentBgSecondary}
      size="small"
      pagination={{ hideOnSinglePage: true, ...props.pagination }}
      {...props}
    />
  );
};

const TableWrapper = styled(AntDTable)<{ $headerBackgroundColor: string }>`
  ${(props) => {
    const onRowImplementation = props.onRow && props.onRow({});
    let styles = `
      .ant-table-thead > tr > th {
        background: ${props.$headerBackgroundColor};
        font-family: "Inter", sans-serif !important;
      }
    `;

    if (onRowImplementation?.onClick) {
      styles += `
        tbody tr:hover {
          cursor: pointer;
        }
      `;
    }
    return styles;
  }}
`;
